import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from '../searchV2.scss';

const MobileModal = ({
    isOpen,
    onClose,
    title,
    children,
    onApply,
    titleClassName,
    showFooter,
    showCancelButton,
}) => {
    useEffect(() => {
        if (isOpen) {
            // Prevent background page scroll when modal is open
            document.body.style.overflow = 'hidden';

            return () => {
                document.body.style.overflow = 'unset';
            };
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);

            return () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    const handleApply = () => {
        if (onApply) {
            onApply();
        }
        onClose();
    };

    return ReactDOM.createPortal(
        <div
            className={styles.mobileModal}
        >
            {/* Header */}
            <div className={styles.mobileModalHeader}>
                <div onClick={onClose} className={styles.mobileModalCloseButton}>
                    <img src="/img/icons/close-icon-lg.svg" alt="Close" />
                </div>
                <div className={`${styles.mobileModalTitle} ${titleClassName || ''}`}>
                    {title}
                </div>
                <div className={styles.mobileModalSpacer} /> {/* Spacer for centering */}
            </div>

            {/* Body */}
            <div className={styles.mobileModalBody}>
                <div className={`mobile-modal-content ${styles.mobileModalContent}`}>
                    {children}
                </div>
            </div>

            {showFooter && (
                <div className={styles.mobileModalFooter}>
                    <button
                        type="button"
                        onClick={handleApply}
                        className={styles.applyButton}
                    >
                        APPLY
                    </button>
                    {showCancelButton && (
                        <button
                            type="button"
                            onClick={onClose}
                            className={styles.cancelButton}
                        >
                            CANCEL
                        </button>
                    )}
                </div>
            )}
        </div>,
        document.body,
    );
};

MobileModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onApply: PropTypes.func,
    titleClassName: PropTypes.string,
    showFooter: PropTypes.bool,
    showCancelButton: PropTypes.bool,
};

MobileModal.defaultProps = {
    onApply: null,
    titleClassName: '',
    showFooter: true,
    showCancelButton: true,
};

export default MobileModal;
